import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { LOGO_URL, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const redirect = (user) => {
    if (from) return navigate(from);
    if (user.role === "admin") return navigate("/admin");
    return navigate("/compte");
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Connexion réussie");
      redirect(user);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src={LOGO_URL} alt="Logo" className="h-16 w-16 object-contain mb-4 rounded-full" />
          <h1 className="font-display text-4xl text-white">Connexion</h1>
          <p className="text-zinc-500 text-sm mt-2">Accédez à votre espace</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
            className="w-full bg-[#0d0d0d] border border-white/15 px-4 py-3 text-white focus:border-[#2563EB] outline-none" />
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe"
            className="w-full bg-[#0d0d0d] border border-white/15 px-4 py-3 text-white focus:border-[#2563EB] outline-none" />
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] disabled:opacity-60 text-white px-10 py-3 text-sm tracking-wide transition-colors">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
          </button>
        </form>
        <p className="text-zinc-500 text-sm text-center mt-8">
          Pas encore de compte ?{" "}
          <Link to="/inscription" state={{ from }} className="text-[#60a5fa] hover:underline" data-testid="go-register">Créer un compte</Link>
        </p>
      </div>
    </div>
  );
}
